import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export function NotAuthorizedPage() {
  const { principalText, logout } = useAuth();
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(principalText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
    }}>
      <div style={{ textAlign: "center", maxWidth: 440 }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔒</div>
        <h2 style={{ marginBottom: 8 }}>Access Restricted</h2>
        <p style={{ color: "var(--color-muted)", fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
          Your Internet Identity is not authorized to access this dashboard.
          Share your principal with the owner to be added as an admin.
        </p>

        <div style={{
          background: "var(--color-surface)",
          border: "1px solid var(--color-border)",
          borderRadius: 4,
          padding: "14px 16px",
          marginBottom: 12,
          textAlign: "left",
        }}>
          <div style={{ fontSize: 11, color: "var(--color-muted)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            Your Principal
          </div>
          <div style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 13,
            color: "var(--color-text)",
            wordBreak: "break-all",
            lineHeight: 1.5,
          }}>
            {principalText}
          </div>
        </div>

        <button
          className="btn-primary"
          style={{ width: "100%", marginBottom: 10 }}
          onClick={copy}
        >
          {copied ? "Copied!" : "Copy Principal"}
        </button>

        <button className="btn-ghost" style={{ width: "100%" }} onClick={logout}>
          Sign out
        </button>
      </div>
    </div>
  );
}
